import React from 'react';
import PropTypes from 'prop-types';

import { COMPARISON_TABLE_CHECK_ICON_SRC } from '../constants';

const comparisonFeatureShape = PropTypes.shape({
  feature: PropTypes.string.isRequired,
  standard: PropTypes.bool.isRequired,
  elevated: PropTypes.bool.isRequired,
});

const dashClassName =
  'text-center text-xl font-light leading-8 text-deep-blue-70';

/** Feature names in the left column of the desktop comparison table. */
export const ComparisonFeatureNameRows = ({ features, rowClassName }) =>
  features.map((item) => (
    <div key={item.feature} className={rowClassName}>
      {item.feature}
    </div>
  ));

ComparisonFeatureNameRows.propTypes = {
  features: PropTypes.arrayOf(comparisonFeatureShape).isRequired,
  rowClassName: PropTypes.string.isRequired,
};

/** Standard or elevated plan column: checkmark or dash per feature row. */
export const ComparisonPlanFeatureRows = ({
  features,
  plan,
  rowClassName,
  checkIconClassName = '',
}) =>
  features.map((item) => (
    <div key={item.feature} className={rowClassName}>
      {item[plan] ? (
        <img
          src={COMPARISON_TABLE_CHECK_ICON_SRC}
          alt="check-icon"
          className={`h-5 w-5 ${checkIconClassName}`.trim()}
        />
      ) : (
        <span className={dashClassName}>-</span>
      )}
    </div>
  ));

ComparisonPlanFeatureRows.propTypes = {
  features: PropTypes.arrayOf(comparisonFeatureShape).isRequired,
  plan: PropTypes.oneOf(['standard', 'elevated']).isRequired,
  rowClassName: PropTypes.string.isRequired,
  checkIconClassName: PropTypes.string,
};
